import React from "react";
import { Switch, Route } from "react-router-dom";
import { Header } from "./common/components/Header/header";
import { UserInfoProvider } from "./providers/user-info-provider";
import ProtectedRoute from "./common/components/ProtectedRoute/protected-route";
import { AppSkeleton } from "./common/components/AppSkeleton/app-skeleton";
import SessionExpired from "./pages/session-expired";
import CampaignsPage from "./pages/campaigns/campaigns-page";
import { CampaignsSkeleton } from "./pages/campaigns/campaigns-skeleton";
import HardwareDetailsPage from "./pages/hardware-details/hardware-details-page";
import SearchResultsHardwarePage from "./pages/hardware-search/hardware-search-page";
import OrdersPage from "./pages/orders/orders-page";
import OrderConfirmationPage from "./pages/confirmation/order-confirmation-page";
import CheckoutPage from "./pages/checkout/checkout-page";
import NotFoundPage from "./pages/not-found/not-found-page";
import { Paths } from "./common/paths/paths";
import { PERMISSIONS, IT_SHOP_URL } from "./config";

const App: React.FC = () => {
  return (
    <Switch>
      <ProtectedRoute
        exact
        path={Paths.campaigns.url}
        requiredPermission={PERMISSIONS.USE_HARDWARE_BASELINE}
        loadingSkeleton={<CampaignsSkeleton />}
      >
        <CampaignsPage />
      </ProtectedRoute>

      <ProtectedRoute
        requiredPermission={PERMISSIONS.USE_HARDWARE_SHOP}
        loadingSkeleton={<AppSkeleton />}
        redirectUrl={IT_SHOP_URL}
      >
        <Header />
        <UserInfoProvider>
          <Switch>
            <Route exact path={Paths.sessionExpired.url} component={SessionExpired} />
            <Route exact path={Paths.search.url} component={SearchResultsHardwarePage} />
            <Route exact path={Paths.orders.url} component={OrdersPage} />
            <Route exact path={Paths.detailsPage.url} component={HardwareDetailsPage} />
            <Route exact path={Paths.checkout.url} component={CheckoutPage} />
            <Route exact path={Paths.confirmation.url} component={OrderConfirmationPage} />
            <Route path={Paths.notFound.url} component={NotFoundPage} />
          </Switch>
        </UserInfoProvider>
      </ProtectedRoute>
    </Switch>
  );
};

export default App;
